import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { crossSellSKUSubstituteData } from "../../services/interfaces/ICrossSellOpportunity";
import { numberFormatter } from "../../utils/formatter";
import { useState } from "react";

const SubstituteTable = ({
  crossellSKULevelDataCopy,
  selectedItemID,
}: any) => {
  const removeLeadingZero = (n: any) => {
    let newStr = n?.replace(/^0+/, "");
    return newStr;
  };

  const [selectedUpdateData, setSelectedUpdateData] = useState<
    Array<string | null>
  >([]);

  return (
    <div className="h-full w-full">
      <div className="business-cost-trend-table mt-[0]">
        <DataTable
          className="h-full w-full"
          value={
            crossellSKULevelDataCopy && selectedItemID
              ? crossellSKULevelDataCopy
              : []
          }
          stripedRows
          scrollable
          scrollHeight="61vh"
          showGridlines
          emptyMessage="No Data Found"
        >
          <Column
            field="gbid"
            header="Item ID"
            body={(rowdata: crossSellSKUSubstituteData) => {
              return (
                <div className="flex-col justify-start items-center">
                {rowdata?.imagelink !== 'NA' && rowdata?.imagelink && <img
                    src={rowdata.imagelink}
                    alt="item-logo"
                    className="w-[7vh] h-[6vh] mb-[.5vh]"
                  />}
                  <span>{removeLeadingZero(rowdata.gbid)}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="master_vendor_name"
            header="Master Vendor Name"
            body={(rowdata: crossSellSKUSubstituteData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{rowdata.master_vendor_name}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="itemDesc"
            header="Item Description"
            body={(rowdata: crossSellSKUSubstituteData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{rowdata.itemDesc}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="LastYear_UnitCost"
            header="Net Cost $/Unit"
            body={(rowdata: crossSellSKUSubstituteData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{numberFormatter(rowdata.LastYear_UnitCost, 2, "$")}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="LastYear_UnitPrice"
            header="Sell Price $/Unit"
            body={(rowdata: crossSellSKUSubstituteData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{numberFormatter(rowdata.LastYear_UnitPrice, 2, "$")}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="LastYear_UnitMargin"
            header="Margin $/Unit"
            body={(rowdata: crossSellSKUSubstituteData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>{numberFormatter(rowdata.LastYear_UnitMargin, 2, "$")}</span>
                </div>
              );
            }}
          ></Column>

          <Column
            field="marginPerc"
            header="Margin %"
            body={(rowdata: crossSellSKUSubstituteData) => {
              return (
                <div className="flex justify-start items-center">
                  <span>
                    {numberFormatter(rowdata.marginPerc * 100, 2)}%
                  </span>
                </div>
              );
            }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default SubstituteTable;
